// extracted by mini-css-extract-plugin
export var results = "DXIThreeUp-module--results--2Q7SH";
export var resultsGrid = "DXIThreeUp-module--results-grid--2jg0l";
export var card = "DXIThreeUp-module--card--2GvmN";
export var cardImage = "DXIThreeUp-module--card-image--1htC8";